<template>
    <div>
        <div class="flex ml-1 mt-3" style="justify-content: space-between;">
            <h5 class="m-0" style="align-self: center;">Quantas pessoas</h5>
            <counter v-model="quantity" :min="1" />
        </div>

        <a-button  type="danger" class="mt-base" id="btn-add" height="50px" block size="large" @click="addTax">
            Adicionar
        </a-button>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import Counter from '../Counter';

    export default {
        components : {
            Counter
        },

        data () {
            return {
                quantity : 1
            }
        },
        
        computed : {
            ...mapState(['AppActiveCompany']),
            ...mapState('taxes', ['taxesToBeSend'])
        },

        methods : {
            addTax () {
                const taxByPerson = this.AppActiveCompany.taxes && this.AppActiveCompany.taxes.byPerson

                this.setTaxByPerson({
                        description : taxByPerson.description,
                        enabled : true,
                        persons : this.quantity,
                        totalByPersonPaid : this.quantity * taxByPerson.value,
                        value : taxByPerson.value
                    }
                )
                this.quantity = 1
                this.$emit('close')
            },

            ...mapActions('taxes', ['setTaxByPerson'])
        }
    }
</script>